import { ServerStream } from "src/types/work-packets";
import type { AccountScopeDeactivationDates, ActivationStatus, ScopeActivationInfo } from "./activation-status-types";

export const ACTIVE_ITEM_STATUS: Readonly<ActivationStatus> = { state: "active" };
export const INACTIVE_ITEM_STATUS: Readonly<ActivationStatus> = { state: "inactive" };

export const ACTIVE_SCOPE_STATUS: Readonly<ScopeActivationInfo> = { isStoreActive: true };
export const INACTIVE_SCOPE_STATUS: Readonly<ScopeActivationInfo> = { isStoreActive: false };

export function evaluateScopeActivationStatus(data: ScopeActivationInfo | undefined): ActivationStatus {
  if (!data) return ACTIVE_ITEM_STATUS; // if account info is not found, assume active
  if (!data.isStoreActive) return INACTIVE_ITEM_STATUS;
  const today = new Date();
  if (data.deactivationDate && today >= data.deactivationDate) {
    return { state: "sunset", deactivationDate: data.deactivationDate };
  } else {
    return ACTIVE_ITEM_STATUS;
  }
}

export function evaluateActivationStatusForStream(
  accountDeactivationDates: AccountScopeDeactivationDates | undefined,
  streamType: ServerStream,
): ActivationStatus {
  if (!accountDeactivationDates) return ACTIVE_ITEM_STATUS;
  return evaluateScopeActivationStatus({
    isStoreActive: accountDeactivationDates.isStoreActive,
    deactivationDate: serverStreamToDeactivationDateGetterMap[streamType](accountDeactivationDates) ?? undefined,
  });
}

type DeactivationDateGetter = (scopes: AccountScopeDeactivationDates) => Date | null;

const serverStreamToDeactivationDateGetterMap: Record<ServerStream, DeactivationDateGetter> = {
  [ServerStream.CHARGEBACKS]: scopes => scopes.chargebacksDeactivationDate,
  [ServerStream.ACCRUAL]: scopes => scopes.accrualsDeactivationDate,
  [ServerStream.PQV]: scopes => scopes.shortagesDeactivationDate,
  // PPV and PRICE_CLAIMS are equivalent
  [ServerStream.PPV]: scopes => scopes.priceClaimsDeactivationDate,
  [ServerStream.PRICE_CLAIMS]: scopes => scopes.priceClaimsDeactivationDate,
};
